jQuery(document).ready(function($) {
    $(".template-product .product__info-wrapper .product-form__controls-group input.hidden, .template-product .product__info-wrapper .product-form__controls-group label.hidden").removeClass('hidden');
    $('li.list-menu__item.facets__item input[value="Hidden"]').parent().hide();
    //   $("input[type='radio']").on("click", function () {
    //     var value = $(this).val(); // Get the clicked radio's value

    //     // Find all radio buttons with the same value and check them (excluding the clicked one)
    //     $("input[type='radio'][value='" + value + "']").not(this).prop("checked", true);
    // });
});

document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver((mutationsList, observer) => {
        let floatedForm = document.querySelector("floated-form");
        if (floatedForm) {
            observer.disconnect(); // Stop observing once the element is found
            initCheckoutButtons(); // Initialize event listeners
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function initCheckoutButtons() {
        document.querySelectorAll(".checkoutBtnDirect").forEach(button => {
            button.addEventListener("click", function (event) {
                event.preventDefault(); // Prevent default anchor behavior
                console.log('Hi I am working');
                let form = this.closest("form");
                let quantityInput = form.querySelector(".quantity__input");
                let variantId = form.querySelector("input[name='id']").value;
                let quantity = quantityInput ? quantityInput.value : 1; // Default to 1 if input is missing

                // Disable button and show loading text
                this.classList.add("disabled");
                this.style.pointerEvents = "none"; // Prevent multiple clicks
                let originalText = this.innerHTML;
                this.innerHTML = "Adding to cart...";

                fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: quantity
                    })
                })
                .then(response => response.json())
                .then(() => {
                    window.location.href = "/checkout";
                })
                .catch(error => {
                    console.error("Error adding to cart:", error);
                    // Revert button state on error
                    this.classList.remove("disabled");
                    this.style.pointerEvents = "auto";
                    this.innerHTML = originalText;
                });
            });
        });
    }
//   $(document).ready(function () {
//     $("input[type='radio']").on("click", function () {
//         var value = $(this).val(); // Get the clicked radio's value

//         // Find all radio buttons with the same value and check them (excluding the clicked one)
//         $("input[type='radio'][value='" + value + "']").not(this).prop("checked", true);
//     });
// });
let isTaskCompleted = false; // Flag to track completion

// Function to sync the floated input when the page loads
function syncCheckedInputOnLoad() {
    // Find all checked radio inputs that start with 'template'
    $('input[type="radio"][id^="template"]:checked').each(function() {
        const value = $(this).val();
        const name = $(this).attr('name');
        
        // Find the corresponding floated input with the same value and name
        const floatedId = this.id.replace('template', 'floated-template');
        const $floatedInput = $('#' + floatedId);
        
        if ($floatedInput.length && !$floatedInput.is(':checked')) {
            $floatedInput.prop('checked', true);
            $floatedInput.prev().click();
            
            // Also trigger any change events if needed
            $floatedInput.trigger('change');
        }
    });
}

// Run the sync function when the page loads
$(document).ready(function() {
    // Initial sync
    syncCheckedInputOnLoad();
    
    // Also run it after a short delay in case floated inputs load later
    setTimeout(syncCheckedInputOnLoad, 500);
});

$(document).on('click', 'label[for^="template"], label[for^="floated-template"]', function (e) {
    if (isTaskCompleted) return; // If the task is already completed, stop further execution.

    const clickedLabelFor = $(this).attr('for');
    const $clickedInput = $('#' + clickedLabelFor);

    if ($clickedInput.length > 0) {
        // Prevent re-executing the task again.
        isTaskCompleted = true;

        // Store the current scroll position
        const scrollPosition = $(window).scrollTop();

        // Let Shopify handle the click normally
        setTimeout(function () {
            const inputVal = $.escapeSelector($clickedInput.val());


            // Find the "sibling" input (different id but same value)
            $('input[type="radio"][value="' + inputVal + '"]').each(function () {
                if (this.id !== clickedLabelFor) {
                    // Click its label (to preserve original logic)
                    $('label[for="' + this.id + '"]').trigger('click');
                }
            });

            // Restore the scroll position after the click is processed
            $(window).scrollTop(scrollPosition);

            // After execution, reset the flag for future actions (if needed).
            isTaskCompleted = false;
        }, 0);
    }
});


// Create a MutationObserver to detect when `.agrs__badge` is added to the DOM
let observerNew = new MutationObserver(function(mutationsList, observer) {
    let reviewWidget = $('.agrs__badge').first(); // Get the first element with the class '.agrs__badge'

    if (reviewWidget.length > 0) {
        $('#googleWidgetCatcher').append(reviewWidget); // Append it to '#googleWidgetCatcher'
        observer.disconnect(); // Stop observing after the element is appended
    }
});

// Configure the observer to watch for changes in the DOM
observerNew.observe(document.body, {
    childList: true,
    subtree: true
});


});
